export default "__VITE_ASSET__c27eb104__"